import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "d-block mt-1 text-danger"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

import { computed, ref } from 'vue';
import { formatDateTime } from '@/utils/date-utils';
import { formatFileName } from '@/utils/file-utils';
import { UploadUtils } from '@/utils/upload-utils';
import { UploadType } from '@/gql/graphql';
import { useUploadsStore } from '@/store/uploads';
import {
  BAlert,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BProgress,
  BProgressBar,
  BTable,
  BTooltip,
} from 'bootstrap-vue-next';
import { UPLOAD_STATUS } from '@/utils/upload-utils';
import UploadAbort from '@/components/upload/UploadAbort.vue';
import UploadResume from '@/components/upload/UploadResume.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WebUploadList',
  props: {
  transparentStyle: { type: Boolean, default: false },
  messageNoItemsFound: {
    type: String,
    default: 'There are no active or recently finished uploads.',
  },
},
  setup(__props) {

const uploadsStore = useUploadsStore();

// --- Component Properties ---
const props = __props;

// --- Component State ---
const noUploads = computed(() => {
  return uploadsStore.uploads.length === 0;
});

const uploadFields = [
  {
    key: 'createdAt',
    label: 'Created At',
    tdClass: 'align-middle',
    formatter: formatDateTime,
    sortable: true,
  },
  {
    key: 'targetFileName',
    label: 'File',
    tdClass: 'align-middle',
    formatter: formatFileName,
    sortable: true,
  },
  {
    key: 'dataRef',
    label: 'Data reference',
    tdClass: 'align-middle',
    sortable: true,
  },
  {
    key: 'cloudProvider',
    label: 'Provider',
    tdClass: 'align-middle text-uppercase',
    sortable: true,
  },
  { key: 'status', label: 'Status', tdClass: 'align-middle', sortable: true },
  { key: 'actions', label: '', tdClass: 'align-middle text-end min-width' },
];

// --- Upload Resume Request ---
function uploadResumeRequested(upload: UploadType) {
  if (!upload.id) {
    console.error('Task resumption requested, but upload ID is missing');
    return;
  }
  selectedUpload.value = upload;
  showUploadResumeModal.value = true;
}

function resumeUploadConfirmed(file: File) {
  // check if the upload object is available
  if (!selectedUpload.value || !selectedUpload.value.id) {
    console.error(
      'Task resumption requested, but upload object or its ID is missing'
    );
    return;
  }
  // resume the upload
  console.debug('Resume upload ', selectedUpload.value.id, 'requested');
  void uploadsStore.resumeUpload(selectedUpload.value, file).catch(() => {
    console.error('Could not resume upload.');
  });
  // close the modal
  showUploadResumeModal.value = false;
  selectedUpload.value = null;
}

function closeUploadResumeModal() {
  showUploadResumeModal.value = false;
  selectedUpload.value = null;
}

// --- Upload Abort Request ---
const selectedUpload = ref<UploadType | null>(null);
const showUploadResumeModal = ref<boolean>(false);
const showConfirmAbortModal = ref<boolean>(false);

function uploadAbortRequested(upload: UploadType) {
  if (!upload.id) {
    console.error('Task cancellation requested, but upload ID is missing');
    return;
  }
  console.debug(
    'Cancel upload ',
    upload.id,
    'requested, waiting for confirmation'
  );
  selectedUpload.value = upload;
  showConfirmAbortModal.value = true;
}

function closeUploadAbortModal() {
  showConfirmAbortModal.value = false;
  selectedUpload.value = null;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BAlert), {
      modelValue: _unref(uploadsStore).error,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(uploadsStore).error) = $event)),
      variant: "danger"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(uploadsStore).error?.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(BAlert), {
      modelValue: noUploads.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((noUploads).value = $event)),
      variant: "secondary"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.messageNoItemsFound), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(uploadsStore).uploads.length > 0)
      ? (_openBlock(), _createBlock(_unref(BCard), {
          key: 0,
          class: _normalizeClass({ 'transparent-card': props.transparentStyle })
        }, {
          default: _withCtx(() => [
            (!_unref(uploadsStore).error && _unref(uploadsStore).uploads.length > 0)
              ? (_openBlock(), _createBlock(_unref(BTable), {
                  key: 0,
                  items: _unref(uploadsStore).uploads,
                  fields: uploadFields,
                  striped: !props.transparentStyle,
                  "thead-tr-class": "transparent-table",
                  "tbody-tr-class": "transparent-table",
                  class: _normalizeClass([
          'browser-table',
          'm-0',
          {
            'table-transparent': props.transparentStyle,
          },
        ]),
                  small: "",
                  responsive: "",
                  hover: ""
                }, {
                  "cell(dataRef)": _withCtx((data) => [
                    (data.item.bucket)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(data.item.bucket.friendlyName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  "cell(status)": _withCtx((data) => [
                    _createVNode(_unref(BProgress), {
                      id: `task-progress-${data.item.id}`,
                      max: "100",
                      animated: _unref(UploadUtils).progressActive(data.item.status),
                      variant: _unref(UploadUtils).progressVariant(data.item.status)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BProgressBar), {
                          value: "100",
                          variant: _unref(UploadUtils).progressVariant(data.item.status)
                        }, {
                          default: _withCtx(() => [
                            (data.item.status === _unref(UPLOAD_STATUS).RUNNING)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(Math.round(data.item.progress)) + "% ", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(data.item.status), 1))
                          ]),
                          _: 2
                        }, 1032, ["variant"])
                      ]),
                      _: 2
                    }, 1032, ["id", "animated", "variant"]),
                    (_unref(uploadsStore).uploadError(data.item.id))
                      ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_unref(uploadsStore).uploadError(data.item.id)), 1))
                      : _createCommentVNode("", true),
                    (data.item.status === _unref(UPLOAD_STATUS).STALE)
                      ? (_openBlock(), _createBlock(_unref(BTooltip), {
                          key: 1,
                          target: `task-progress-${data.item.id}`
                        }, {
                          default: _withCtx(() => [
                            _cache[3] || (_cache[3] = _createTextVNode(" The download appears to have stalled, possibly due to the app being closed or reloaded, or due to slow network conditions. This may occur if another instance of the app (in a different tab or device) is handling the upload. If that’s the case, you can ignore this message. Otherwise, click the ", -1)),
                            _createVNode(_unref(BBadge), { variant: "light" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "rotate-right" }),
                                _cache[2] || (_cache[2] = _createTextVNode(" Resume", -1))
                              ]),
                              _: 1
                            }),
                            _cache[4] || (_cache[4] = _createTextVNode(" button to continue the download from its last state. ", -1))
                          ]),
                          _: 1
                        }, 8, ["target"]))
                      : _createCommentVNode("", true)
                  ]),
                  "cell(actions)": _withCtx((data) => [
                    _createVNode(_unref(BButtonGroup), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BButton), {
                          size: "sm",
                          variant: "outline-dark",
                          id: `link-bucket-${data.item.id}`,
                          disabled: !data.item.bucket,
                          to: 
                data.item.bucket && !data.item.bucket.deletedAt
                  ? {
                      name: 'BucketDetail',
                      params: { id: data.item.bucket.id },
                    }
                  : undefined
              
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "database" })
                          ]),
                          _: 1
                        }, 8, ["id", "disabled", "to"]),
                        _createVNode(_unref(BTooltip), {
                          target: `link-bucket-${data.item.id}`
                        }, {
                          default: _withCtx(() => [
                            (data.item.bucket.deletedAt)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                  _createVNode(_component_font_awesome_icon, { icon: "exclamation-triangle" }),
                                  _cache[5] || (_cache[5] = _createTextVNode(" Data have been deleted ", -1))
                                ]))
                              : (data.item.bucket)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "database",
                                      class: "me-2"
                                    }),
                                    _createElementVNode("strong", null, _toDisplayString(data.item.bucket.friendlyName), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                    _createVNode(_component_font_awesome_icon, { icon: "exclamation-triangle" }),
                                    _cache[6] || (_cache[6] = _createTextVNode(" No Data ", -1))
                                  ]))
                          ]),
                          _: 2
                        }, 1032, ["target"]),
                        _createVNode(_unref(BButton), {
                          id: `resume-upload-${data.item.id}`,
                          disabled: !_unref(UploadUtils).canBeResumed(data.item.status),
                          size: "sm",
                          variant: "outline-dark",
                          onClick: ($event: any) => (uploadResumeRequested(data.item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "rotate-right" })
                          ]),
                          _: 1
                        }, 8, ["id", "disabled", "onClick"]),
                        _createVNode(_unref(BTooltip), {
                          target: `resume-upload-${data.item.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode(" Resume ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["target"]),
                        _createVNode(_unref(BButton), {
                          disabled: !_unref(UploadUtils).canBeAborted(data.item.status),
                          id: `cancel-upload-${data.item.id}`,
                          size: "sm",
                          variant: "outline-danger",
                          onClick: ($event: any) => (uploadAbortRequested(data.item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ]),
                          _: 1
                        }, 8, ["disabled", "id", "onClick"]),
                        _createVNode(_unref(BTooltip), {
                          target: `cancel-upload-${data.item.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" Abort ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["target"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["items", "striped", "class"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (showUploadResumeModal.value && selectedUpload.value)
      ? (_openBlock(), _createBlock(UploadResume, {
          key: 1,
          show: showUploadResumeModal.value,
          upload: selectedUpload.value,
          onClose: closeUploadResumeModal,
          onSuccess: resumeUploadConfirmed
        }, null, 8, ["show", "upload"]))
      : _createCommentVNode("", true),
    (showConfirmAbortModal.value && selectedUpload.value)
      ? (_openBlock(), _createBlock(UploadAbort, {
          key: 2,
          show: showConfirmAbortModal.value,
          upload: selectedUpload.value,
          onClose: closeUploadAbortModal,
          onCloseAndRefresh: closeUploadAbortModal
        }, null, 8, ["show", "upload"]))
      : _createCommentVNode("", true)
  ]))
}
}

})